import { DEFAULT_AVATAR } from 'types/constants'
import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const defaultAvatarUrlResolver: FieldResolver = (metadata: Metadata) =>
  ({ defaultAvatarUrl: metadata.isDeleted() ? undefined : DEFAULT_AVATAR } as StreamData)

export default defaultAvatarUrlResolver
